import {
  SET_POSTS,
  GET_POST,
  SUBMIT_COMMENT,
  LIKE_POST,
  UNLIKE_POST,
  DELETE_POST,
  UPDATE_POST,
  ADD_POST,
  DELETE_COMMENT,
} from '../types/posts';

import {
  getPostByIdService,
  createPostService,
  submitCommentService,
  getAllPostService,
  getAllEventPostService,
  likePostService,
  unlikePostService,
  deletePostService,
  updatePostService,
  deleteCommentService,
} from '../services/postService';
import { getAllActivities } from '../../redux/actions/activityActions';
import { SET_ERRORS, CLEAR_ERRORS, LOADING_UI } from '../types/ui';

export const getAllPosts = (topicId) => async (dispatch) => {
  try {
    const allPosts = await getAllPostService(topicId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_POSTS, payload: allPosts });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const getAllEventPosts = (eventId) => async (dispatch) => {
  try {
    const allPosts = await getAllEventPostService(eventId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_POSTS, payload: allPosts });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const getPostById = (postId) => async (dispatch) => {
  try {
    const postById = await getPostByIdService(postId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: GET_POST, payload: postById });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const createPost = (newPost) => async (dispatch) => {
  try {
    await createPostService(newPost);
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const submitComment =
  (owner, commentBody, postId) => async (dispatch) => {
    await submitCommentService({
      owner,
      commentBody,
      postId,
    });
    await dispatch(getAllActivities());
  };

export const deleteComment = (commentId, id) => async (dispatch) => {
  try {
    const deleteCommentDb = await deleteCommentService({
      commentId,
      id,
    });
    await dispatch(getAllActivities());
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: DELETE_COMMENT, payload: deleteCommentDb });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const likePost = (postId, userId) => async (dispatch) => {
  try {
    const likedPost = await likePostService(postId, { userId });
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: LIKE_POST, payload: likedPost });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const unlikePost = (postId, userId) => async (dispatch) => {
  try {
    const unlikedPost = await unlikePostService(postId, { userId });
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: UNLIKE_POST, payload: unlikedPost });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const updatePost = (postId, body) => async (dispatch) => {
  try {
    const updatedPostDb = await updatePostService(postId, body);
    await dispatch({ type: CLEAR_ERRORS });
    await dispatch({ type: UPDATE_POST, payload: updatedPostDb });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const deletePost = (postId) => async (dispatch) => {
  try {
    await deletePostService(postId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: DELETE_POST, payload: postId });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};
